import { Component, OnDestroy, inject } from '@angular/core';
import { AlertMessage, AlertService, AlertType } from '@shared/services/alert';
import { Subscription } from 'rxjs';
import { Timeout } from '@nomidio/common';

/**
 * The alert bar component displays on-page alert messages raised by AlertService.
 */
@Component({
  selector: 'app-alert-bar',
  templateUrl: './alert-bar.component.html',
  styleUrls: ['./alert-bar.component.scss'],
  standalone: false,
})
export class AlertBarComponent implements OnDestroy {
  private alertService = inject(AlertService);

  private readonly ALERT_CLEAR_TIME_MS = 10 * 1000;
  public readonly AlertType = AlertType;
  public alert: AlertMessage | null = null;
  public clearMessageTimeout: Timeout;
  private readonly alertsSub: Subscription;

  constructor() {
    this.alertsSub = this.alertService.alerts.subscribe((message: AlertMessage | null) => {
      this.alert = message;
      this.clearTimer();
      if (message) {
        this.clearMessageTimeout = setTimeout(() => {
          this.alert = null;
          this.clearTimer();
        }, this.ALERT_CLEAR_TIME_MS);
      }
    });
  }

  public get ariaRole(): string {
    switch (this.alert?.type) {
      case AlertType.Error:
        return 'error';
      case AlertType.Success:
        return 'success';
      default:
        return '';
    }
  }

  private clearTimer(): void {
    clearTimeout(this.clearMessageTimeout);
    this.clearMessageTimeout = null;
  }

  ngOnDestroy() {
    this.alertsSub.unsubscribe();
  }
}
